
/* injects from baggage-loader */

'use strict';

const APP_ID = 'machine-document-qa';
const SERVER_URL = 'https://api-qa.machinedocument.com/parse';
const LIVE_QUERY_URL = 'wss://api-qa.machinedocument.com/parse';

function runBlock($log, $rootScope, $interval, Parse, Snackbar, APP_VERSION) {
	'ngInject';

	$rootScope.appVersion = APP_VERSION;
	$log.log('App version:', APP_VERSION);

	Parse.initialize(APP_ID);
	Parse.serverURL = SERVER_URL;
	Parse.liveQueryServerURL = LIVE_QUERY_URL;
	Parse.Config.get().then(data => $rootScope.appConfig = data.attributes);

	// Enable maxbox
	// mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN;

	// Main application state
	$rootScope.state = {
		transitions: {},
		newerAppAvailable: false
	};

	// Site theme
	$rootScope.theme = {
		dark: false
	}

	// Global snackbar dismissal function
	$rootScope.dismissSnackbar = event => {
		if (event.currentTarget) {
			event.currentTarget.remove();
		} else {
			event.target.remove();
		}
	}

	// Check for a newer version of the app every half hour
	$interval(() => {
		Parse.Config.get().then(data => {
			$rootScope.appConfig = data.attributes;
			if ($rootScope.appConfig.appVersion > $rootScope.appVersion && !$rootScope.state.newerAppAvailable) {
				Snackbar.open('A newer version of Machine Document is available. Refresh your browser to load it.', {
					icon: 'fa-info-circle',
					addClass: 'bg-primary',
					duration: 0
				});
				$rootScope.state.newerAppAvailable = true;
			}
		});	
	}, 60000 * 30)

}

export default runBlock;


// WEBPACK FOOTER //
// ./src/app/index.run.js